import React from 'react';
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalHeader,
	RegularButton,
	Typography,
} from 'fronton-react';
import { ModalDelivery, Fabrics, Sewing, Time } from '../icons';
import { fabricsButtonHref, texts } from './constants';
import {
	modalContentItemStyles,
	modalFooterStyles,
	modalHeaderSmMobileStyles,
	modalHeaderStyles,
	modalIconStyles,
	modalTitleStyles,
} from './styles';

type ModalProps = {
	isOpen: boolean;
	icon?: React.ReactNode;
	onClose: VoidFunction;
};

type BaseModalProps = ModalProps & {
	button: React.ReactNode;
	title: string;
	contentItems: string[];
};

type SewingModalProps = ModalProps & {
	onClick: VoidFunction;
};

type DeliveryModalProps = ModalProps & {
	onClick: VoidFunction;
};

const BaseModal = ({ isOpen, title, contentItems, button, onClose, icon }: BaseModalProps) => (
	<>
		{isOpen && (
			<Modal variant="curtain" onClose={onClose} show={isOpen} size="s">
				<ModalHeader className={modalHeaderStyles} title={title} label="" />
				<div className={modalHeaderSmMobileStyles}>
					<div className={modalIconStyles}>{icon}</div>
					<div className={modalTitleStyles}>
						<Typography as="span" variant="h2">
							{title}
						</Typography>
					</div>
				</div>
				<ModalContent>
					{contentItems.map(item => (
						<Typography
							key={item}
							className={modalContentItemStyles}
							as="p"
							size="body_long"
							variant="m"
						>
							{item}
						</Typography>
					))}
				</ModalContent>
				<ModalFooter className={modalFooterStyles}>{button}</ModalFooter>
			</Modal>
		)}
	</>
);

export const FabricsModal = ({ isOpen, onClose }: ModalProps) => (
	<BaseModal
		isOpen={isOpen}
		onClose={onClose}
		title={texts.modals.fabrics.title}
		icon={<Fabrics />}
		contentItems={texts.modals.fabrics.contentItems}
		button={
			<RegularButton
				data-qa="fabrics-modal-btn"
				size="l"
				variant="primary"
				href={fabricsButtonHref}
				target="_blank"
			>
				{texts.modals.fabrics.button}
			</RegularButton>
		}
	/>
);

export const TimeModal = ({ isOpen, onClose }: ModalProps) => (
	<BaseModal
		isOpen={isOpen}
		onClose={onClose}
		title={texts.modals.time.title}
		icon={<Time />}
		contentItems={texts.modals.time.contentItems}
		button={
			<RegularButton size="l" variant="secondary" onClick={onClose}>
				{texts.modals.time.button}
			</RegularButton>
		}
	/>
);

export const SewingModal = ({ isOpen, onClick, onClose }: SewingModalProps) => {
	const handleClick = () => {
		onClose();
		onClick();
	};
	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title={texts.modals.sewing.title}
			icon={<Sewing />}
			contentItems={texts.modals.sewing.contentItems}
			button={
				<RegularButton size="l" variant="primary" onClick={handleClick}>
					{texts.modals.sewing.button}
				</RegularButton>
			}
		/>
	);
};

export const DeliveryModal = ({ isOpen, onClick, onClose }: DeliveryModalProps) => {
	const handleClick = () => {
		onClose();
		onClick();
	};
	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title={texts.modals.delivery.title}
			icon={<ModalDelivery />}
			contentItems={texts.modals.delivery.contentItems}
			button={
				<RegularButton size="l" variant="primary" onClick={handleClick}>
					{texts.modals.delivery.button}
				</RegularButton>
			}
		/>
	);
};
